module.exports = __webpack_public_path__ + "static/social_audio-068ef0444dfeb1d5f79bd47f0ad6a4cf.jpg";